import HasFormMixin from "./HasFormMixin";

export default {

    mixins: [HasFormMixin],

    props: {
        label: {},
        name: {
            required: true
        },
        showError: {
            default: true
        },
        showLabel: {
            default: true
        }
    },

    mounted() {
        if (this.$bus) {
            this.$bus.$emit('InputComponent:mounted', this);
        }
    },

    computed: {
        model: {
            get() {
                return _.get(this.form, this.name);
            },
            set(value) {
                _.set(this.form, this.name, value);
            }
        },
        error() {
            let errors = _.get(this.form.errors.errors, this.name);

            return errors && errors.length ? errors[0] : '';
        }
    },

    beforeDestroy() {
        if (this.$bus) {
            this.$bus.$emit('InputComponent:destroy', this);
        }
    },

    watch: {
        model() {
            this.form.errors.clear(this.name);
        }
    }
}
